import { styled, CSSObject } from "@mui/material/styles";
import { cvar } from "styles";

const baseTimeStyles: CSSObject = {
  fontSize: "40px",
  fontWeight: 500,
  fontFamily: "Poppins",
  color: cvar("darkest-blue"),
};
export const StyledToolBarDate = styled("span")(() => ({
  ...baseTimeStyles,
}));

export const StyledInputWrapper = styled("span")(() => ({
  display: "inline-block",
  float: "left",
  width: "96px",
}));

export const StyledInputLabel = styled("span")(() => ({
  textTransform: "uppercase",
  fontWeight: "700",
  color: cvar("nepal-blue"),
  fontSize: "11px",
  letterSpacing: "0.4px",
}));

export const StyledInputTime = styled("input")(() => ({
  ...baseTimeStyles,
  height: "60px",
  width: "96px",
  background: cvar("cotton-boll"),
  fontWeight: "500",
  lineHeight: "52px",
  textAlign: "center",
  borderRadius: "8px",
  border: `1px solid ${cvar("botticelli-blue")}`,
  "::-webkit-inner-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
  "::-webkit-outer-spin-button": {
    "-webkit-appearance": "none",
    margin: 0,
  },
}));
export const StyledInputTimeColon = styled("span")(() => ({
  ...baseTimeStyles,
  height: "60px",
  width: "24px",
  fontWeight: "500",
  lineHeight: "52px",
  textAlign: "center",
  float: "left",
}));

export const sxStyle = {
  borderRadius: "12px",
  position: "fixed",
  "& .MuiPickersArrowSwitcher-button, .MuiPickersCalendarHeader-switchViewButton": {
    svg: {
      path: {
        fill: cvar("darkest-blue"),
        height: 10,
      },
    },
  },
  "& .MuiPickersDay-root": {
    color: cvar("queen-blue"),
    fontWeight: "600",
    lineHeight: "16px",
    fontSize: "14px",
    fontFamily: "Barlow",
  },
  "& .css-3eghsz-PrivatePickersYear-button": {
    color: cvar("queen-blue"),
    fontWeight: "500",
    lineHeight: "16px",
    fontSize: "14px",
  },

  "& .css-ueukts-MuiButtonBase-root-MuiToggleButton-root.Mui-selected": {
    color: "white",
  },
  "& .MuiToggleButton-root": {
    fontFamily: "Poppins",
  },
  "& .MuiButtonBase-root-MuiPickersDay-root.Mui-selected": {
    background: `linear-gradient(270.54deg, ${cvar("picton-blue")} 49.88%, ${cvar("blue-ribbon")} 135.73%)`,

    color: "white",
  },

  "& .MuiDayPicker-weekDayLabel": {
    color: cvar("darkest-blue"),
    fontWeight: "600",
    fontFamily: "Barlow",
  },
  "& .Mui-selected": {
    background: `linear-gradient(270.54deg, ${cvar("picton-blue")} 49.88%, ${cvar("blue-ribbon")} 135.73%)`,
    color: cvar("white"),
  },
  "& .MuiPickersDay-today": {
    background: cvar("cotton-boll"),
    border: "none !important",
  },
  "& .MuiPickersCalendarHeader-label": {
    color: cvar("darkest-blue"),
    fontWeight: "600",
    lineHeight: "20px",
    align: "center",
    fontSize: "14px",
    fontFamily: "Barlow",
  },

  "& .MuiGrid2-root": {
    display: "flex",
  },
  "& .MuiCalendarOrClockPicker-root": {
    alignItems: "center",
  },
};
